import React, {SyntheticEvent, useCallback, useRef, useState, useEffect} from 'react';
import intl from "react-intl-universal";
import classNames from "classnames";

import {Button} from "../../components/Button";


import './TrashMenuConfirmation.css';


export interface TrashMenuConfirmationProps {
    onCancel: () => void;
    mainAction: () => Promise<void>;
    mainActionText: string;
    headerText: string;
    className?: string;
    noHover?: boolean;
}

export const TrashMenuConfirmation = (
    {
        onCancel,
        mainAction,
        mainActionText,
        headerText,
        className,
        noHover = false,
    }: TrashMenuConfirmationProps) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const isUnmountedRef = useRef(false);

    const onClick = useCallback((event: SyntheticEvent) => {
        event.stopPropagation();
        if (!isProcessing) {
            setIsProcessing(true);
            mainAction().then(() => {
                if (!isUnmountedRef.current) {
                    setIsProcessing(false);
                }
            });
        }
    }, [mainAction, isProcessing, setIsProcessing])

    useEffect(() => {
        return () => {
            isUnmountedRef.current = true;
        };
    }, []);

    return (
        <div className={classNames({
            'TrashMenuConfirmation body-medium': true,
            'TrashMenuConfirmation--noHover': noHover,
            [className!]: className,
        })}>
            <div className='TrashMenuConfirmation__title title-small'>{headerText}</div>
            <div
                className='TrashMenuConfirmation__message'>{intl.get('view-addition.empty-trash-confirm-message').d("You can't undo this action.")}</div>
            <div className='TrashMenuConfirmation__buttons'>
                <Button
                    style="plain"
                    type="neutral"
                    onClick={onCancel}
                    className="TrashMenuConfirmation__button"
                    text={intl.get('common.cancel').d("Cancel")}
                    size={'sm'}
                />
                <Button
                    type="danger"
                    style="solid"
                    onClick={onClick}
                    className="TrashMenuConfirmation__button"
                    text={mainActionText}
                    loading={isProcessing}
                    size={'sm'}
                />
            </div>
        </div>
    )
}